// Typelizer digest 9e33578b932b6b1f036509b29b6979f1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/counterparties/bulk_deletion */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/counterparties/bulk_deletion', {}, options),
    method: 'post',
  }),
}
